import React from 'react';

interface SectionDescriptionProps {
  title: string;
  description: string;
}

export function SectionDescription({ title, description }: SectionDescriptionProps) {
  return (
    <div className="section-description">
      <div className="title">{title}</div>
      <div className="description">{description}</div>
    </div>
  );
}
